import {combineLatest} from 'rxjs';
import {tradePair$} from '@/state/trade-pair';
import {toUiMsg$} from '@/ui';
import {book$, fixationBook$} from './book';
import {toWsMsg$} from '@/ws';
import type {Book, PairBase} from '@/types';

export interface UBook {
  type: 'orderbook';
  data: {
    book: Book;
  };
}

export interface UFixationBook {
  type: 'fixation-order-book';
  data: {
    book: Book;
  };
}

export function subscribeBook() {
  tradePair$.subscribe((tradePair: PairBase) => {
    const isPerpetualV2 = tradePair.type === 'PerpetualV2';
    const unSubTopic = isPerpetualV2 ? 'orderbook_p.unsubscribe' : 'orderbook.unsubscribe';
    const subTopic = isPerpetualV2 ? 'orderbook_p.subscribe' : 'orderbook.subscribe';
    toWsMsg$.next({method: unSubTopic, params: []});
    toWsMsg$.next({method: subTopic, params: [tradePair.symbol, true]});
  });

  combineLatest([tradePair$, book$]).subscribe(([tradePair, book]: [PairBase, Book]) => {
    const showBook = filterBook(tradePair);
    toUiMsg$.next({type: 'orderbook', data: {book: showBook ? book : createInit()}});
  });

  combineLatest([tradePair$, fixationBook$]).subscribe(([tradePair, book]: [PairBase, Book]) => {
    const showBook = filterBook(tradePair);
    toUiMsg$.next({type: 'fixation-order-book', data: {book: showBook ? book : createInit()}});
  });
}

function filterBook(tradePair: PairBase) {
  const [, listTime] = tradePair.timeline || [0, 0];
  return Date.now() > listTime;
}

function createInit() {
  return {
    reset: true,
    symbol: '',
    ask1Ep: 0,
    ask1EpRaw: 0,
    asks: [],
    bid1Ep: 0,
    bid1EpRaw: 0,
    bids: [],
  };
}
